import { clearToken, getToken } from './storage';

export class ApiError extends Error {
  code?: number;

  constructor(message: string, code?: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
  }
}

const apiPrefix = '/gateway';

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const token = getToken();
  const response = await fetch(`${apiPrefix}${url}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { token } : {}),
      ...(init?.headers || {})
    }
  });

  const payload = await response.json();
  if (payload?.code === 200) {
    return payload.data as T;
  }

  if ([301, 302, 303, 304, 305].includes(payload?.code)) {
    clearToken();
    window.dispatchEvent(new CustomEvent('auth:expired'));
  }

  throw new ApiError(payload?.msg || '请求失败', payload?.code);
}

async function requestForm<T>(url: string, formData: FormData, init?: RequestInit): Promise<T> {
  const token = getToken();
  const response = await fetch(`${apiPrefix}${url}`, {
    ...init,
    method: init?.method || 'POST',
    headers: {
      ...(token ? { token } : {}),
      ...(init?.headers || {})
    },
    body: formData
  });

  const payload = await response.json();
  if (payload?.code === 200) {
    return payload.data as T;
  }

  if ([301, 302, 303, 304, 305].includes(payload?.code)) {
    clearToken();
    window.dispatchEvent(new CustomEvent('auth:expired'));
  }

  throw new ApiError(payload?.msg || '请求失败', payload?.code);
}

export function get<T>(url: string, params?: Record<string, unknown>) {
  const query = params
    ? `?${new URLSearchParams(
        Object.entries(params)
          .filter(([, value]) => value !== undefined && value !== null)
          .map(([key, value]) => [key, String(value)])
      ).toString()}`
    : '';
  return request<T>(`${url}${query}`);
}

export function post<T>(url: string, data?: unknown) {
  return request<T>(url, {
    method: 'POST',
    body: JSON.stringify(data ?? {})
  });
}

export function put<T>(url: string, data?: unknown) {
  return request<T>(url, {
    method: 'PUT',
    body: JSON.stringify(data ?? {})
  });
}

export function del<T>(url: string, params?: Record<string, unknown>) {
  const query = params
    ? `?${new URLSearchParams(
        Object.entries(params)
          .filter(([, value]) => value !== undefined && value !== null)
          .map(([key, value]) => [key, String(value)])
      ).toString()}`
    : '';
  return request<T>(`${url}${query}`, {
    method: 'DELETE'
  });
}

export function postForm<T>(url: string, formData: FormData, init?: RequestInit) {
  return requestForm<T>(url, formData, init);
}
